export default __webpack_public_path__ + "static/expeditions@2x-compress-13e393c538816c299af47823c9e0fe60.jpg";